import { useState, useEffect } from 'react';
import {
  useGetReadingSetCoursesMutation,
  useGetLevelsMutation,
  useGetSetsMutation,
  useAddSetsToAssignmentMutation
} from '../../../../../features/authentication/questionSearchApiSlice';
import DropDownSelect from '../../../../../components/DropDownSelect';
import DropDownSearch from '../../../../../components/DropDownSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import SetThumbnail from '../components/SetThumbnail';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DataProvider } from '../../../../assignments/DataContext';
import AssignmentCreateContent from '../../../../assignments/components/AssignmentCreateContent';
import AddQuestionsToExisting from '../../../components/castleQuestionsSearch/components/questionResults/components/addQuestionsToExisting';
import CustomToast from '../../../../../components/Toast';
import { useNavigate, useParams } from 'react-router-dom';
import { useAssignmentContext } from '../../../../assignments/context';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import AddQuestionsToAssignment from '../../../components/addQuestionsToAssignment';
import AssignmentStatus from '../../../../../enums/assignmentStatus';
import PageNavigation from '../../../../../components/pageNavigation';
import CreateQuestionSetModel from '../../../../myContent/pages/questionSets/components/CreateQuestionSetModel';
import { useAddSetsToQSetMutation } from '../../../../../features/authentication/qSetApiSlice';

const CastleReadingSets = () => {
  const pageSize = 8;
  const [courses, setCourses] = useState([]);
  const [levels, setLevels] = useState([]);
  const [setTypes, setSetTypes] = useState([]);
  const [lexile] = useState(
    [
      { id: 'All', name: 'All' },
      { id: '0-200', name: '0-200' },
      { id: '200-400', name: '200-400' },
      { id: '400-600', name: '400-600' },
      { id: '600-800', name: '600-800' },
      { id: '800-1000', name: '800-1000' },
      { id: '1000-1200', name: '1000-1200' },
      { id: '1200', name: 'Above 1200' }
    ]);
  const [setData, setSetData] = useState([]);
  const [searchString, setSearchString] = useState('');

  const [selectedCourseId, setSelectedCourseId] = useState(-1);
  const [selectedLevelIds, setSelectedLevelIds] = useState([]);
  const [selectedSetTypeId, setSelectedSetTypeId] = useState(-1);
  const [selectedLexileId, setSelectedLexileId] = useState('All');

  const [selectedCourseName, setSelectedCourseName] = useState('');
  const [selectedLevelName, setSelectedLevelName] = useState('');
  const [selectedSetTypeName, setSelectedSetTypeName] = useState('All');
  const [selectedLexileName, setSelectedLexileName] = useState('All');

  const [getReadingSetCourses, {isLoading:isLoadingCourse}] = useGetReadingSetCoursesMutation();
  const [getLevels] = useGetLevelsMutation();
  const [getSets, {isLoading}] = useGetSetsMutation();
  const [addSetsToAssignment] = useAddSetsToAssignmentMutation();
  const [addSetsToQSet] = useAddSetsToQSetMutation();

  const [pageCount, setPageCount] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const [openOptionTileModal, setOpenOptionTileModal] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [dateBasedKey] = useState(new Date().getTime().toString());
  const [selectedSetIds, setSelectedSetIds] = useState([]);
  const { assignmentId, from, qSetId } = useParams();
  const { mcChoices, assignmentAssignedViaDetails, setAssignmentAssignedViaDetails } = useAssignmentContext();
  const navigate = useNavigate();
  const [initial, setInitial] = useState(true);
  const [confirmModel, setConfirmModel] = useState(false);
  const [openQsetCreateModal, setOpenQsetCreateModal] = useState(false);

  const saveComponentAddToExisting = <AddQuestionsToExisting key={'update' + dateBasedKey}
    handleSave={(id) => addSetQuestionsToExistingAssignment(id)}
    handleCancel={() => setOpenOptionTileModal(false)} />;

  const saveComponentCreate =
    <DataProvider>
      <AssignmentCreateContent
        key={'create' + dateBasedKey}
        showBrowseContent={false}
        showTitle={false} showCancelButton={true}
        handleCancel={() => setOpenOptionTileModal(false)}
        onCreateSuccess={(id, assignedViaDetails) => addSetQuestionsToExistingAssignment(id, assignedViaDetails)}
      />
    </DataProvider>;

  const handleAddConfirmation = () => {
    if(from == 'qSet')
    {
      if(qSetId)
        addSetQuestionsToExistingQSet(qSetId);
      else
        setOpenQsetCreateModal(true);
    }
    else{
      if (assignmentId) {
        addSetQuestionsToExistingAssignment(assignmentId);
      } else {
        setOpenOptionTileModal(true);
      }
    }
    setConfirmModel(false);
  };

  const addSetQuestionsToExistingAssignment = async (existingAssignmentId, assignedViaDetails) => {
    var options = {
      assignmentId: existingAssignmentId,
      setIds: selectedSetIds
    };
    const response = await addSetsToAssignment(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      CustomToast('Selected Sets questions are added', 'success');
      const updatedItems = setData.map(item => ({
        ...item,
        isSelected: false
      }));
      setSetData(updatedItems);
      setOpenOptionTileModal(false);

      if (assignmentAssignedViaDetails?.id == null && assignedViaDetails?.id != null)
        setAssignmentAssignedViaDetails({ assignedViaDetails });

      navigate('/assignments/' + existingAssignmentId + '/edit_assignment', { state: { assignedStatus: AssignmentStatus.NotAssigned, mcChoices: mcChoices } });
    }
  };

  const addSetQuestionsToExistingQSet = async (qSetId) => {
    var options = {
      id: qSetId,
      setIds: selectedSetIds
    };
    const response = await addSetsToQSet(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      CustomToast('Selected Sets questions are added', 'success');     
      setOpenQsetCreateModal(false);
      navigate('/mycontent/questionsets/'+qSetId+'/questions');
    }
  };

  useEffect(() => {
    getCoursesAsync();
  }, []);

  useEffect(() => {
    setSelectedSetTypeId(-1);
    setSelectedSetTypeName('All');
    if (selectedCourseId >= 0)
      getLevelsAsync();
  }, [selectedCourseId]);

  useEffect(() => {
    if (selectedLevelIds.length > 0 && selectedCourseId >= 0 && initial) {
      getSetsAsync(0, pageSize);
    }
  }, [selectedLevelIds, selectedCourseId]);


  const handleSearch = () => {
    setIsSearch(true);
    if(selectedLevelIds.length == 0){
      CustomToast('Please select a level to search.','warning');
      return;
    }
    setSelectedSetIds([]);
    setSetData([]);
    setSelectedPage(1);
    getSetsAsync(0, pageSize);
  };

  const getCoursesAsync = async () => {
    const options = {
      assignmentId: assignmentId ? assignmentId : 0
    };
    const response = await getReadingSetCourses(options).unwrap();
    const checkedCourse = response.filter(item => item.selected);
    if (checkedCourse.length === 0) {
      //setting courseid default as english
      setSelectedCourseId(24);
      setSelectedCourseName('English(HS)');
    }
    else {
      setSelectedCourseId(checkedCourse[0].id);
      setSelectedCourseName(checkedCourse[0].name);
    }
    setCourses(response);
  };

  const getLevelsAsync = async () => {
    setSelectedLevelIds([]);
    const option = {
      courseId: selectedCourseId
    };
    const response = await getLevels(option).unwrap();
    setSelectedLevelIds([parseInt(response[0].id)]);
    const updatedLevels = response.map((item,index) => ({
      ...item,
      isChecked: index == 0
    }));
    setLevels(updatedLevels);
  };

  const getSetsAsync = async (skip, take) => {
    setInitial(false);
    const params = new URLSearchParams();
    params.append('courseId', parseInt(selectedCourseId));
    selectedLevelIds.forEach(item => params.append('levelId', item));
    params.append('lexile', selectedLexileId);
    params.append('setType', selectedSetTypeName);
    params.append('searchString', searchString);
    params.append('skip', skip);
    params.append('take', take);
    params.append('pageSize', pageSize);

    const response = await getSets(params.toString());
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      let readingSets = response.data.readingSets;
      if (selectedSetIds.length > 0 && !isSearch) {
        readingSets = response.data.readingSets.map((item) =>
          selectedSetIds.includes(item.setId) ? { ...item, isSelected: true } : item
        );
      }
      setPageCount(response.data.pageCount);
      setSetData(readingSets);
      const setTypesArray = [];
      response.data.subTopics.map((item) => {
        if (item.topicName.length > 0) {
          const obj = {
            id: item.topicId,
            name: item.topicName
          };
          setTypesArray.push(obj);
        }
      });
      const objData = {
        id: -1,
        name: 'All'
      };
      const setTypesArrayResponse = [objData, ...setTypesArray];
      setSetTypes(setTypesArrayResponse);
    }
    setIsSearch(false);
  };

  const handleSelectPage = (pageNumber) => {
    if (pageNumber == selectedPage) return;
    setSelectedPage(pageNumber);
    const skipValue = (pageNumber - 1) * pageSize;
    getSetsAsync(skipValue, pageSize);
  };

  const handleAddSets = async () => {
    if (!selectedSetIds || selectedSetIds.length == 0) {
      CustomToast('Please select sets to add', 'error');
      return;
    }
    setConfirmModel(true);
  };

  const handleText = (e) => {
    const searchString = e.target.value;
    setSearchString(searchString);
  };

  const handleLevels = (e) =>{
    const { key } = e;
    const selected = key !== '000' ? levels.find((v) => v.id == key) : levels;
    let tempArray = [];
    if (key === '000') {
      tempArray = levels.map((item) => ({
        ...item,
        isChecked: !levels.filter((item) => item?.isChecked !== true).length < 1
      }));
    } else {
      tempArray = levels.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setLevels(tempArray);
    const ids = tempArray.filter((item) => item?.isChecked === true).map((itemId) =>parseInt(itemId.id));
    setSelectedLevelIds(ids);
  };

  return (
    <>
      <div className='white-card'>
        <div className='w-100 d-flex gap-3'>
          <div className='w-100'>
            <p className='w-100'>Course</p>
            <DropDownSelect
              value={courses}
              selectedId={selectedCourseId}
              setSelectedId={setSelectedCourseId}
              dropdownId="courseList"
              selectedName={selectedCourseName}
              setSelectedName={setSelectedCourseName}
            />
          </div>
          <div className='w-100'>
            <div className='d-flex gap-2'>
              <div><p className='w-100'>Difficulty Level</p></div>
              <div className='mt-1'>
                <OverlayTrigger
                  key="set-topic-info"
                  placement="top"
                  overlay={
                    <Tooltip id="parent-tooltip" className="folder-info">
                      “A” = Primary Basic<br />
                      “B” = Primary Intermediate<br />
                      “C” = Primary Advanced<br />
                      “D” = Elementary Basic<br />
                      “E” = Elementary Intermediate<br />
                      “F” = Elementary Advanced<br />
                      “G” = Middle Basic<br />
                      “H” = Middle Intermediate<br />
                      “I” = Middle Advanced<br />
                      “J” = High School Basic<br />
                      “K” = High School Intermediate<br />
                      “L” = High School Advanced<br />
                      “M” = AP Level
                    </Tooltip>
                  }>
                  <FontAwesomeIcon icon={faCircleQuestion} className="circle-question" />
                </OverlayTrigger>
              </div>
            </div>
            <DropDownSearch
              value={levels}
              selectedId={selectedLevelIds}
              setSelectedId={setSelectedLevelIds}
              dropdownId="levelList"
              selectedName={selectedLevelName}
              setSelectedName={setSelectedLevelName}
              handleChange={(e) => handleLevels(e)}
              placeholder='Levels'
              selectAllText="All Levels"
              showValidation ={selectedLevelIds.length == 0 || levels.every(item => item?.isChecked === false) ? true : false}
            />
          </div>
          <div className='w-100'>
            <p className='w-100'>Set Type</p>
            <DropDownSelect
              value={setTypes}
              selectedId={selectedSetTypeId}
              setSelectedId={setSelectedSetTypeId}
              dropdownId="settypelist"
              selectedName={selectedSetTypeName}
              setSelectedName={setSelectedSetTypeName}
            />
          </div>
          <div className='w-100'>
            <p className='w-100'>Lexile</p>
            <DropDownSelect
              value={lexile}
              selectedId={selectedLexileId}
              setSelectedId={setSelectedLexileId}
              dropdownId="lexileList"
              selectedName={selectedLexileName}
              setSelectedName={setSelectedLexileName}
            />
          </div>
        </div>
        <div className='w-100 d-flex gap-3'>
        </div>
        <div className='w-100 d-flex gap-2 mt-3'>
          <div className="custom-search position-relative mb-2 w-100">
            <FontAwesomeIcon icon={faSearch} />
            <input type="text" className="form-control" placeholder='Keyword' onChange={handleText} />
          </div>
          <div>
            <button className="btn outline-btn" onClick={() => handleSearch()}>
              Search
            </button>
          </div>
        </div>
      </div>
      <div className='white-card mt-4'>
        <div className='w-100 d-flex mb-4 gap-2'>
          <div><h6 className='w-100'>Sets from Topic</h6></div>
          <div>
            <OverlayTrigger
              key="set-topic-info"
              placement="top"
              overlay={
                <Tooltip id="parent-tooltip" className="folder-info">
                  Select a <strong>Course</strong> and then a <strong>Difficulty Level</strong> to see available Reading Sets
                </Tooltip>
              }>
              <FontAwesomeIcon icon={faCircleQuestion} className="circle-question" />
            </OverlayTrigger>
          </div>
        </div>
        {setData &&
          <SetThumbnail
            setDetails={setData}
            setSetDetails={setSetData}
            setSelectedSetIds={setSelectedSetIds}
            selectedSetIds={selectedSetIds}
            isLoading={isLoading || isLoadingCourse}
            selectedCourseId={selectedCourseId}
          />
        }
        {setData.length > 0 &&
          <div className='selectionDetailsBar'>
            <div className='d-flex flex-row align-items-center'>
              <span className='fw-bold'>Selected:</span><span className='selectionTypeCount'>{selectedSetIds.length}</span>
            </div>
            {pageCount > 1 && <PageNavigation handleSelectPage={handleSelectPage} currentPage={selectedPage} pageCount={pageCount} />}
            <div>
              <Button variant='castleRed' onClick={() => handleAddSets()}>Add Set To {from == 'qSet'? 'Question Set': 'Assignment'}</Button>
            </div>
          </div>
        }
      </div>
      {openOptionTileModal &&
        <>
          <AddQuestionsToAssignment
            key={'component' + dateBasedKey}
            openOptionTileModal={openOptionTileModal}
            setOpenOptionTileModal={setOpenOptionTileModal}
            saveComponentCreate={saveComponentCreate}
            saveComponentAddToExisting={saveComponentAddToExisting}
          />
        </>
      }

      {openQsetCreateModal &&
        <CreateQuestionSetModel
          key={'createQSet' + dateBasedKey}
          isOpen={openQsetCreateModal}
          onClose={() => setOpenQsetCreateModal(false)}
          showQuestionOptions={false}
          onCreateSuccess={(id)=>addSetQuestionsToExistingQSet(id)}
        />
      }
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => handleAddConfirmation()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={`Are you sure that you want to add the selected sets to the ${from == 'qSet'? 'Question Set': 'Assignment'}?`}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
    </>
  );
};

export default CastleReadingSets;
